import { Box, BoxProps, ColorOptions, Icon, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useEffect, useState } from 'react'
import { ModalAlertView } from '../../components/ModalAlertView'
import { TextInputWithCb } from '../../components/TextInputWithCb'
import { useLazyApiData, useStores } from '../../data/store'
import { convertCamelCaseToString, isAccessible } from '../../utils'
import { UpdateEntity } from './UpdateEntity'

interface EditEntityProps {
  entityId: string
  data?: any
}

const NON_EDITABLE_FIELDS = ['ID', 'createdAt', 'createdBy', 'createdFrom', 'updatedAt', 'updatedBy', 'updatedFrom']

const EditEntity: FC<EditEntityProps> = ({
  route: {
    params: { entityData = JSON.parse(localStorage.getItem('params')) },
  },
}: any) => {
  useEffect(() => {
    entityData && localStorage.setItem('params', JSON.stringify(entityData))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [isModal, setModal] = useState(false)

  const navigation = useNavigation()
  const [toggleDelete, setDelete] = useState(false)

  const { deleteEntityAction, accessConfig } = useStores((store) => ({
    deleteEntityAction: store.entityMaster.deleteEntity,
    accessConfig: store.user.getAccessConfig(['entity_config', 'entity_master']),
  }))

  const [selectedArr, setSelectedArr] = useState<any>([])
  const [lazydeleteEntity, lazydeleteEntityHandler] = useLazyApiData(deleteEntityAction)

  const handleEdit = () => {
    selectedArr?.length > 0 && setModal(true)
  }

  const deleteEntity = () => {
    setDelete(true)
  }

  const handleDelete = () => {
    lazydeleteEntity(entityData?.ID)
    setDelete(false)
    navigation.navigate('entitymaster')
  }

  const onUpdate = () => {
    setModal(false)
    navigation.navigate('entitymaster')
  }

  const handleSelection = (obj: any, isChecked: boolean) => {
    if (isChecked) {
      const arr: any = selectedArr
      arr.push(obj)
      setSelectedArr(arr)
    } else {
      setSelectedArr(selectedArr.filter((item) => !item.hasOwnProperty(Object.keys(obj)?.[0])))
    }
  }
  return (
    <Box>
      <ModalAlertView
        show={toggleDelete}
        onDismiss={() => setDelete(false)}
        onCancel={() => setDelete(false)}
        title="Delete Processor"
        message={`Is this final. This will delete processor with ID ${entityData?.ID}`}
        onPress={handleDelete}
        buttonTitle="Delete"
        isLoading={lazydeleteEntityHandler.state === 'pending'}
      />

      <Text
        title={`Details for Entity ID: ${entityData?.ID}`}
        fontSize={28}
        fontWeight={'600'}
        color={'#5a5c69' as ColorOptions}
      />
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        {...styles.header}
        bg={'#f8f9fc' as ColorOptions}
        paddingHorizontal={24}
        paddingVertical={16}>
        <Text
          fontFamily={'jiotype-bold'}
          fontSize={16}
          color={'#214796' as ColorOptions}
          title={'Select fields to update.'}
          testID={'text-select'}
        />
        <Box flexDirection="row" alignSelf="flex-end">
          {isAccessible(accessConfig, 'update') && (
            <Box
              flexDirection="row"
              backgroundColor="ORANGE"
              padding={8}
              borderRadius={4}
              onPress={handleEdit}
              testID={'btn-entity-update'}
              underlayColor="YELLOW">
              <Icon id="EDIT" size="FONT_SIZE_LARGE" color="WHITE" />
              <Spacer direction="horizontal" size={4} />
              <Text color="WHITE">Edit</Text>
            </Box>
          )}
          <Spacer direction="horizontal" size={16} />
          {isAccessible(accessConfig, 'delete') && (
            <Box
              flexDirection="row"
              backgroundColor="RED"
              padding={8}
              borderRadius={4}
              testID={'btn-entity-delete'}
              onPress={deleteEntity}
              underlayColor="ERROR">
              <Icon id="DELETE" size="FONT_SIZE_LARGE" color="WHITE" />
              <Spacer direction="horizontal" size={4} />
              <Text color="WHITE">Delete</Text>
            </Box>
          )}
        </Box>
      </Box>
      <Box {...styles.dataContainer}>
        {Object.keys(entityData).map(function (key, index) {
          return (
            <Box paddingVertical={8} pr={16} minWidth={'50%'}>
              <TextInputWithCb
                testID={'edit-entity-' + index}
                label={key !== 'ID' ? convertCamelCaseToString(key) : 'Id'}
                value={entityData[key] ?? ''}
                showCheckbox={!NON_EDITABLE_FIELDS.includes(key)}
                onChange={handleSelection}
              />
            </Box>
          )
        })}
      </Box>
      <ModalDialog
        children={
          <UpdateEntity
            initialData={entityData}
            id={entityData?.ID}
            onUpdate={onUpdate}
            onClose={() => setModal(false)}
            selectedArr={selectedArr}
            show={isModal}
          />
        }
        onDismiss={() => setModal(false)}
        show={isModal}
        type={'CenteredWrap'}
      />
    </Box>
  )
}

export default EditEntity

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    backgroundColor: 'BACKGROUND',
    underlayColor: 'WHITE',
  } as BoxProps,
  header: {
    ...shadow,
    marginTop: 16,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  dataContainer: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
    p: 24,
    backgroundColor: 'WHITE',
    flexDirection: 'row',
    flexWrap: 'wrap',
  } as BoxProps,
}
